export default __webpack_public_path__ + "static/media/do-1@3x.d65fe99a.jpg";